/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Tc_OffsetInputs */

const en_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC Offset`)
};

const fr_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décalage TC`)
};

const de_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC Offset`)
};

const it_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset TC`)
};

const ru_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смещение TC`)
};

const es_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento de TC`)
};

const zh_cn2_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC偏移`)
};

const ja_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TCオフセット`)
};

const hi_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीसी ऑफसेट`)
};

const pt_pt2_dialogue_list_export_tc_offset = /** @type {(inputs: Dialogue_List_Export_Tc_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento TC`)
};

/**
* | output |
* | --- |
* | "TC Offset" |
*
* @param {Dialogue_List_Export_Tc_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_tc_offset = /** @type {((inputs?: Dialogue_List_Export_Tc_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Tc_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_tc_offset(inputs)
	if (locale === "de") return de_dialogue_list_export_tc_offset(inputs)
	if (locale === "it") return it_dialogue_list_export_tc_offset(inputs)
	if (locale === "ru") return ru_dialogue_list_export_tc_offset(inputs)
	if (locale === "es") return es_dialogue_list_export_tc_offset(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_tc_offset(inputs)
	if (locale === "ja") return ja_dialogue_list_export_tc_offset(inputs)
	if (locale === "hi") return hi_dialogue_list_export_tc_offset(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_tc_offset(inputs)
	return en_dialogue_list_export_tc_offset(inputs)
});